export const MODAL_NAME = 'Company details';
